export const formatPhoneFR = (phone = "") => {
  const digits = String(phone || "").replace(/\D/g, "");

  if (digits.length === 10) {
    return digits.replace(/(\d{2})(?=\d)/g, "$1 ").trim();
  }

  return phone || "";
};

export const cleanUrl = (url = "") => {
  return String(url || "").replace(/\/$/, "");
};

export const getRegisterUrl = (settings = {}, fallbackSiteUrl = "") => {
  const baseUrl = cleanUrl(settings?.siteweb_club || fallbackSiteUrl || "");

  if (!baseUrl) return "";

  return `${baseUrl}/`;
};

export const getDisplaySiteUrl = (url = "") => {
  return String(url || "")
    .replace(/^https?:\/\//, "")
    .replace(/\/$/, "");
};

export const getAssetUrl = (assetPath = "") => {
  if (!assetPath) return "";

  if (/^https?:\/\//i.test(assetPath)) {
    return assetPath;
  }

  const rawApiUrl =
    process.env.REACT_APP_API_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_BACKEND_URL ||
    "";

  const apiOrigin = rawApiUrl
    .replace(/\/api\/?$/, "")
    .replace(/\/$/, "");

  if (!apiOrigin) {
    return assetPath;
  }

  return `${apiOrigin}${assetPath.startsWith("/") ? "" : "/"}${assetPath}`;
};

export const getClubInitials = (settings = {}) => {
  const source =
    settings?.shortname_club ||
    settings?.nom_club ||
    settings?.commune_club ||
    "Club";

  return String(source)
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word[0]?.toUpperCase())
    .join("");
};

export const safeFileName = (value = "affiche-inscription") => {
  return String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9-_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();
};